/**
 * Базовый URL бэкенда: runtime-конфиг (инъекция в Docker entrypoint) → build-time env.
 *
 * Вынесен из client.ts, чтобы platformToken.ts мог обменивать токен «голым» axios
 * (без интерсепторов клиента) и не создавать цикл импортов client ↔ platformToken.
 */

export function resolveApiUrl(): string {
  const rc = (window as any).__RUNTIME_CONFIG__ as Record<string, string> | undefined;
  return rc?.API_URL || import.meta.env.VITE_API_URL || 'http://localhost:8064';
}

export const API_URL = resolveApiUrl();
